export const defaultSettings = {
  dateValue: null,
  textColor: '#000000',
  backgroundColor: '#ffffff',
};
